<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->
  <div
    class="us-refurb-process-card border border-static-default-mid rounded-sm p-24 flex flex-col gap-24 mt-16"
  >
    <div class="flex justify-between">
      <div class="heading-3 max-w-[250px] text-action-default-hi">
        {{ i18n(translations.title) }}
      </div>

      <RevIllustration
        alt=""
        :height="60"
        src="/img/product/us/back-market-badge.png"
        :width="60"
      />
    </div>

    <ul class="grid grid-cols-3 gap-12">
      <li class="max-w-[100px]">
        <div class="heading-1 text-static-default-hi">
          {{ i18n(translations.titleAdvantage1) }}
        </div>
        <div class="body-2 text-static-default-mid">
          {{ i18n(translations.contentAdvantage1) }}
        </div>
      </li>

      <li class="max-w-[100px]">
        <div class="heading-1 text-static-default-hi">
          {{ i18n(translations.titleAdvantage2) }}
        </div>
        <div class="body-2 text-static-default-mid">
          {{ i18n(translations.contentAdvantage2) }}
        </div>
      </li>

      <li class="max-w-[100px]">
        <div class="heading-1 text-static-default-hi">
          {{ i18n(translations.titleAdvantage3) }}
        </div>
        <div class="body-2 text-static-default-mid">
          {{ i18n(translations.contentAdvantage3) }}
        </div>
      </li>
    </ul>

    <RevLink
      class="flex text-static-default-hi"
      :tracking="{ zone: 'refurb_process_card', name: 'see_how_it_works' }"
      @click="openModal(MODAL_NAMES.REFURB_PROCESS)"
    >
      <div class="body-1-link">{{ i18n(translations.seeHowItWorks) }}</div>
      <IconChevronRight class="size-24" />
    </RevLink>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './USRefurbProcessCard.translations'

const i18n = useI18n()
</script>

<style scoped>
.us-refurb-process-card {
  --grid-size: 100px;
  --grid-line: transparent 90deg, rgb(231 233 237) 0;
  --grid-background-color: rgb(242 244 248);

  background:
    conic-gradient(from 90deg at 1px 1px, var(--grid-line)),
    conic-gradient(from 90deg at 1px 1px, var(--grid-line)),
    var(--grid-background-color);
  background-size:
    var(--grid-size) var(--grid-size),
    calc(var(--grid-size) / 6) calc(var(--grid-size) / 6);
}
</style>
